import React from 'react';

const StPatricksDecorations = () => {
  // Generate shamrocks
  const shamrocks = Array.from({ length: 20 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 8,
    duration: 10 + Math.random() * 5,
    size: 16 + Math.random() * 16,
    opacity: 0.4 + Math.random() * 0.3,
  }));

  // Generate gold coins
  const coins = Array.from({ length: 10 }, (_, i) => ({
    id: i,
    left: Math.random() * 100,
    delay: Math.random() * 12,
    duration: 8 + Math.random() * 4,
    size: 14 + Math.random() * 10,
  }));

  return (
    <div className="fixed inset-0 pointer-events-none z-40 overflow-hidden">
      {/* Shamrocks */}
      {shamrocks.map((shamrock) => (
        <div
          key={`shamrock-${shamrock.id}`}
          className="absolute animate-float-leaf"
          style={{
            left: `${shamrock.left}%`,
            top: '-40px',
            fontSize: `${shamrock.size}px`,
            opacity: shamrock.opacity,
            animationDelay: `${shamrock.delay}s`,
            animationDuration: `${shamrock.duration}s`,
          }}
        >
          ☘️
        </div>
      ))}

      {/* Gold coins */}
      {coins.map((coin) => (
        <div
          key={`coin-${coin.id}`}
          className="absolute animate-shimmer"
          style={{
            left: `${coin.left}%`,
            top: `${20 + Math.random() * 60}%`,
            fontSize: `${coin.size}px`,
            animationDelay: `${coin.delay}s`,
          }}
        >
          🪙
        </div>
      ))}

      {/* Green gradient overlay at edges */}
      <div className="absolute top-0 left-0 w-24 h-full bg-gradient-to-r from-green-500/10 to-transparent" />
      <div className="absolute top-0 right-0 w-24 h-full bg-gradient-to-l from-green-500/10 to-transparent" />
    </div>
  );
};

export default StPatricksDecorations;
